// extracted by mini-css-extract-plugin
export default {"total":"Row_total__+m+lq","shadowTop":"Row_shadowTop__b5u9U","placeHolderShimmer":"Row_placeHolderShimmer__9-8Ib"};